export const TIMELINE_CLICKED_TIME_KEY = "timeline_clicked_time";

export const getTimelineClickedTime = (): string | null =>
  localStorage.getItem(TIMELINE_CLICKED_TIME_KEY);

export const clearTimelineClickedTime = (): void => {
  localStorage.removeItem(TIMELINE_CLICKED_TIME_KEY);
};
